<h2 mat-dialog-title>Well Mappings — {{ data.feedName }}</h2>
<div mat-dialog-content class="legacy-xref-dialog-content">
  <app-legacy-xref-editor [dataFeedId]="data.dataFeedId"></app-legacy-xref-editor>
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="close()">Close</button>
</div>
